import React from 'react';
import MyForm from './MyForm';
import Display from './Display';

function Post()
{
    return (
        <>
            <h4>Post Data!!!</h4>
            <MyForm/>
            <Display/>
        </>
    )
}

export default Post;